import AlertDetailsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AlertDetailsPage";
import Classes from "model";
import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "bcms-react";
import { getAlertDetailsAccountWidgetConfig } from "components/pages/AlertDetailsPage/components/AlertDetailsAccountWidget";

export default function CaptureNotifiAlertAccountSelected(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    let data = getDefaultPageData("1");
    const details = data.notificationDetails.map(info => {
        info.isEnabled = "false";
        info.amount = 0;

        return info;
    }, []);

    data = BCMSStateManagerCRUD.init(data)
        .update([ "notificationDetails" ], details)
        .submit();

    const widgetConfig = getAlertDetailsAccountWidgetConfig();
    widgetConfig.toggle.isActive = true;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "Detail_0" ], widgetConfig)
        .submit();

    return <AlertDetailsPage data={ data } ui={ ui } />
}